module.exports = __webpack_public_path__ + "media/images/icons/academy-english-606a1d956d3a61f622b3c6d9edda4ec5.svg";